import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Registration } from 'src/app/api/registration/registration';
import { RegistrationApiService } from 'src/app/api/registration/registrationApiService';

@Component({
    selector: 'registration-details',
    templateUrl: './registration-details.component.html',
    styleUrls: ['./registration-details.component.css'],
    host: {'class': 'registration-details'},
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RegistrationDetailsComponent implements OnInit {
  @Input() assetId: string | undefined = undefined;
  registration: Registration | null = null;
  loading: boolean = false;

  constructor(
    private registrationApiService: RegistrationApiService
  ) { }

  ngOnInit(): void {
    if (!this.assetId)
      return;

    this.loading = true;
    this.registrationApiService.getRegistrationsForAsset(this.assetId)
      .subscribe((x) => {
        this.registration = x[0];
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.registration = null;
        console.error(error);
      });
  }
}
